import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import DaumPostcode from 'react-daum-postcode';
import CustomModal from '../../components/modal/CustomModal';
import StoreController, { CurrentStoreContext, StoreType } from '../../controller/StoreController';
import { useToast } from '../../controller/ToastController';

const HotelInfo = () => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [kHotelName, setKhotelName] = useState<string>('');
  const [eHotelName, setEhotelName] = useState<string>('');
  const [sAddress, setAddress] = useState<string>('');
  const [sExtraAddress, setExAddress] = useState<string>('');
  const [hotelNumber, setHotelNumber] = useState<string>('');
  const [addressModal, setAddressModal] = useState<boolean>(false);
  const [bCode, setBcode] = useState<string>('');

  const handleKHotelNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setKhotelName(event.target.value);
  };
  const handleEHotelNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEhotelName(event.target.value);
  };
  const handleHotelNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHotelNumber(event.target.value);
  };
  const onChange_sExtraAddress = (event: any) => {
    setExAddress(event.target.value);
  };

  // 다음주소검색
  const handleComplete = async (data: any) => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }
    setAddress(fullAddress);
    setAddressModal(false);
    setBcode(data.bcode);
  };
  const handleAddressModalClose = () => {
    setAddressModal(false);
  };

  const getHotelInfo = async () => {
    try {
      const store_id = currentStore.value;
      const oRes: any = await StoreController.getStore(store_id);

      if (oRes && oRes.data) {
        const oResponse: StoreType = oRes.data.data;
        setKhotelName(oResponse.store_name);
        setEhotelName(oResponse.store_name_en);
        setAddress(oResponse.address1);
        setExAddress(oResponse.address2);
        setHotelNumber(oResponse.phone_number);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };
  const submitHotelInfo = async () => {
    if (currentStore.value === null) {
      showToast('문제가 발생했습니다. 로그아웃 후 재로그인해주세요.', 'error');
    } else if (kHotelName === '') {
      showToast('호텔명을 입력해주세요.', 'error');
    } else if (eHotelName === '') {
      setEhotelName(kHotelName);
    } else if (sAddress === '') {
      showToast('호텔주소를 입력해주세요.', 'error');
    } else if (sExtraAddress === '') {
      showToast('호텔 상세 주소를 입력해주세요.', 'error');
    } else if (hotelNumber === '') {
      showToast('호텔 전화번호를 입력해주세요.', 'error');
    } else {
      try {
        const oParams = {
          store_id: currentStore.value,
          store_name: kHotelName,
          store_name_en: eHotelName,
          address1: sAddress,
          address2: sExtraAddress,
          phone_number: hotelNumber,
          bcode: bCode,
          store_detail: [],
          description_noti: '',
          description_event: '',
          description_extra: '',
        };
        const oRes: any = await StoreController.editStore(oParams);

        if (oRes && oRes.data) {
          const oResponse: any = oRes.data;

          if (oResponse.data) {
            showToast('매장정보를 저장했어요');
          }
        }
      } catch (err) {
        console.log('err-->', err);
      }
    }
  };
  React.useEffect(() => {
    getHotelInfo();
  }, [currentStore]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>호텔명</h4>
              <h5>(필수)</h5>
            </div>
            <div className="inputWrap">
              <input
                type="text"
                value={kHotelName}
                onChange={handleKHotelNameChange}
                placeholder="호텔명을 입력해주세요"
              />
            </div>
          </div>
          <div className="inputText">
            <div className="title initial">
              <h4>호텔명(영어)</h4>
            </div>
            <div className="inputWrap">
              <input
                type="text"
                value={eHotelName}
                onChange={handleEHotelNameChange}
                placeholder="호텔명을 영어로 입력해주세요"
              />
            </div>
          </div>
          <div className="inputText">
            <div className="title initial">
              <h4>호텔 주소</h4>
              <h5>(필수)</h5>
            </div>
            <div className="address">
              <input
                type="text"
                disabled
                value={sAddress}
                placeholder="도로명 주소를 입력해주세요"
                autoFocus={false}
                style={{ marginBottom: '8px', backgroundColor: '#ffffff' }}
              />
              <button
                className="searchBox"
                onClick={() => {
                  setAddressModal(true);
                }}>
                <img src={`${process.env.PUBLIC_URL}/svg/ic_search.svg`} alt="search" />
              </button>
            </div>
            <input
              type="text"
              placeholder="상세주소를 입력해주세요"
              value={sExtraAddress}
              onChange={onChange_sExtraAddress}
              autoFocus={false}
            />
          </div>
          <div className="inputText">
            <div className="title initial">
              <h4>호텔 전화번호</h4>
              <h5>(필수)</h5>
            </div>
            <div className="inputWrap">
              <input
                type="number"
                value={hotelNumber}
                onChange={handleHotelNumberChange}
                placeholder="-없이 입력해주세요"
              />
            </div>
          </div>
          <div onClick={submitHotelInfo} className="submitButton">
            저장
          </div>
        </div>
      </Style>
      <CustomModal isVisible={addressModal} setVisible={setAddressModal}>
        <div style={{ display: 'flex' }}>
          <button
            onClick={handleAddressModalClose}
            style={{ marginLeft: 'auto', marginRight: '1%' }}>
            <img src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`} alt="ic" />
          </button>
        </div>
        <DaumPostcode
          onComplete={handleComplete}
          onClose={handleAddressModalClose}
          autoClose
          style={{ height: window.innerWidth > 1200 ? '54vh' : '70vh' }}
        />
      </CustomModal>
    </>
  );
};

export default HotelInfo;

const Style = styled.div`
  /* inputText */
  .inputText {
    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: flex-start;
      gap: 4px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .greyFont {
        color: #a7a7a7;
      }
      h4 {
        color: #555555;
      }
    }

    input {
      width: 100%;
      padding: 10px 22px;
      margin-top: 6px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }
  }

  /* 주소검색 */
  .address {
    position: relative;

    .searchBox {
      margin-bottom: 8px;
      position: absolute;
      top: 6px;
      bottom: 0;
      right: 0%;
      padding: 0 20px;
      border: none;
      background: #4dd2ae;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 700;
      display: flex;
      align-items: center;
    }
  }

  /* submitButton */
  .submitButton {
    width: 100%;
    margin-top: 200px;
    text-align: center;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
